/* eslint-disable global-require */

/**
 *  Typography
 */
import { fontFamilyPrimary } from './mixins';
export var fontFamily = "'Hind Vadodara', sans-serif";
export var fontSizeBase = 14;
export var fontFamilyBase = fontFamily;
var fonts = {
  families: {
    base: fontFamilyBase,
    primary: fontFamily
  },
  fontFace: "".concat(fontFamilyPrimary),
  sizes: {
    base: "".concat(fontSizeBase, "px"),
    medium: "".concat(fontSizeBase + 2, "px"),
    large: "".concat(fontSizeBase + 4, "px"),
    caption: "".concat(fontSizeBase - 2, "px"),
    small: "".concat(fontSizeBase, "px"),
    h1: "".concat(fontSizeBase + 38, "px"),
    h3: "".concat(fontSizeBase + 10, "px"),
    h2: "".concat(fontSizeBase + 18, "px"),
    h5: "".concat(fontSizeBase, "px"),
    h4: "".concat(fontSizeBase + 2, "px"),
    h6: "".concat(fontSizeBase - 2, "px")
  }
};
export default fonts;